import { Action } from 'redux';

import { PaymentMethodCategory } from 'models';
export { isLoading, doneLoading } from 'store/config/actions';

// ----------------------- Portal-OTC Parent Actions ------------------------
export const SAVE_PAYMENT_METHOD_OPTIONS = 'payment-method/PUT_ACCEPTED_PAYMENT_OPTIONS';
export interface SavePaymentMethodOptionsAction extends Action<typeof SAVE_PAYMENT_METHOD_OPTIONS> {
  readonly payload: {
    readonly type: PaymentMethodCategory;
    readonly paymentMethodsOTC: ReadonlyArray<PaymentMethodType>;
    readonly paymentMethodsPortal: ReadonlyArray<PaymentMethodType>;
  };
}

export const savePaymentMethodOptions = (
  data: SavePaymentMethodOptionsAction['payload'],
): SavePaymentMethodOptionsAction => ({
  payload: data,
  type: SAVE_PAYMENT_METHOD_OPTIONS,
});

// ----------------------- OTC Actions ------------------------

// Lookup payment method actions
export const GET_PAYMENT_METHOD_OPTIONS_OTC = 'payment-method/LOOKUP_PAYMENT_OPTIONS_OTC';
export interface GetPaymentMethodOptionsOTCAction extends Action<typeof GET_PAYMENT_METHOD_OPTIONS_OTC> {
  readonly payload: PaymentMethodCategory;
}

export const PERSIST_PAYMENT_METHOD_OPTIONS_OTC = 'payment-method/LOOKUP_PAYMENT_OPTIONS_OTC_COMPLETE';
export interface PersistPaymentMethodOptionsOTCAction extends Action<typeof PERSIST_PAYMENT_METHOD_OPTIONS_OTC> {
  readonly payload: ClientPaymentMethods;
}

export const SAVE_PAYMENT_METHOD_OPTIONS_OTC = 'payment-method/PUT_ACCEPTED_PAYMENT_OPTIONS_OTC';
export interface SavePaymentMethodOptionsOTCAction {
  readonly type: typeof SAVE_PAYMENT_METHOD_OPTIONS_OTC;
  readonly payload: ReadonlyArray<PaymentMethodType>;
}

export type PaymentMethodOptionsOTCAction =
  GetPaymentMethodOptionsOTCAction | PersistPaymentMethodOptionsOTCAction | SavePaymentMethodOptionsOTCAction;

export const getPaymentMethodOptionsOTC = (type: PaymentMethodCategory): GetPaymentMethodOptionsOTCAction => ({
  payload: type,
  type: GET_PAYMENT_METHOD_OPTIONS_OTC,
});

export const persistPaymentMethodOptionsOTC = (
  paymentMethods: ClientPaymentMethods,
): PersistPaymentMethodOptionsOTCAction => ({
  payload: paymentMethods,
  type: PERSIST_PAYMENT_METHOD_OPTIONS_OTC,
});

export const savePaymentMethodOptionsOTC = (
  data: ReadonlyArray<PaymentMethodType>,
): SavePaymentMethodOptionsOTCAction => ({
  payload: data,
  type: SAVE_PAYMENT_METHOD_OPTIONS_OTC,
});

// ----------------------- PORTAL Actions ------------------------

// Lookup payment method actions
export const GET_PAYMENT_METHOD_OPTIONS_PORTAL = 'payment-method/LOOKUP_PAYMENT_OPTIONS_PORTAL';
export interface GetPaymentMethodOptionsPortalAction extends Action<typeof GET_PAYMENT_METHOD_OPTIONS_PORTAL> {
  readonly payload: PaymentMethodCategory;
}

export const PERSIST_PAYMENT_METHOD_OPTIONS_PORTAL = 'payment-method/LOOKUP_PAYMENT_OPTIONS_PORTAL_COMPLETE';
export interface PersistPaymentMethodOptionsPortalAction extends Action<typeof PERSIST_PAYMENT_METHOD_OPTIONS_PORTAL> {
  readonly payload: ClientPaymentMethods;
}

export const SAVE_PAYMENT_METHOD_OPTIONS_PORTAL = 'payment-method/PUT_ACCEPTED_PAYMENT_OPTIONS_PORTAL';
export interface SavePaymentMethodOptionsPortalAction {
  readonly type: typeof SAVE_PAYMENT_METHOD_OPTIONS_PORTAL;
  readonly payload: ReadonlyArray<PaymentMethodType>;
}

export type PaymentMethodOptionsPortalAction =
  GetPaymentMethodOptionsPortalAction | PersistPaymentMethodOptionsPortalAction | SavePaymentMethodOptionsPortalAction;

export const getPaymentMethodOptionsPortal = (type: PaymentMethodCategory): GetPaymentMethodOptionsPortalAction => ({
  payload: type,
  type: GET_PAYMENT_METHOD_OPTIONS_PORTAL,
});

export const persistPaymentMethodOptionsPortal = (
  paymentMethods: ClientPaymentMethods,
): PersistPaymentMethodOptionsPortalAction => ({
  payload: paymentMethods,
  type: PERSIST_PAYMENT_METHOD_OPTIONS_PORTAL,
});

export const savePaymentMethodOptionsPortal = (
  data: ReadonlyArray<PaymentMethodType>,
): SavePaymentMethodOptionsPortalAction => ({
  payload: data,
  type: SAVE_PAYMENT_METHOD_OPTIONS_PORTAL,
});
